module.exports = __webpack_public_path__ + "img/logo.90828e7e.svg";